const MY_PRODUCT_REGISTRATION_ACCESS_TOKEN =
    "de540731a5b9998364fd9806f980e79dcbce5ba7db21fd3a8be746cff7f74378";

const STOREFRONT_API_KEY = 'd543f364d6dd1d75be810b7a0b6dd09b'


const GRAPHQL_ENDPOINT = `https://${Shopify.shop}/api/2023-01/graphql.json`


export { MY_PRODUCT_REGISTRATION_ACCESS_TOKEN, STOREFRONT_API_KEY, GRAPHQL_ENDPOINT }